<template>

  <cd-layout>

    <template #page-title>
      Your Orders
    </template>

    <template #page-meta>
      <table class="order-top order-table">
        <tr>
          <th class="t-qty">
            Qty
          </th>
          <th class="t-name">
            Product Name
          </th>
          <th class="t-discount">
            Discount
          </th>
          <th class="t-total">
            Total
          </th>
        </tr>
      </table>
    </template>

    <template #page-body>
      <div class="order" v-if="orderItems.length && cdIsOpen">
        <b-card
          no-body
          v-for="(item,index) in orderItems"
          v-bind:key="index"
          class="list-complete-item">
          <b-card-header
            class="orders-item-head p-0">

            <div
              class="btn">

              <div class="order-item">
                <table class="order-table">
                  <tr>
                    <td class="t-qty" data-title="Qty">
                      <strong>
                        <i>{{ item.quantity }}</i>
                      </strong>
                    </td>
                    <td class="t-name" data-title="Name">
                      <span>{{ item.name }}</span>
                    </td>
                    <td class="t-discount" data-title="Discount">
                      <strong>
                        <i>
                          {{ item.discount > 0 ? '- $'+item.discount.toFixed(2) : '$'+item.discount.toFixed(2)}}
                        </i>
                      </strong>
                    </td>
                    <td class="t-total" data-title="Total">
                      <strong>
                        <i>
                          {{ getItemSubtotal(item) >= 0 ? '$' + getItemSubtotal(item).toFixed(2)  : '- $'+(-1*getItemSubtotal(item)).toFixed(2)   }}
                        </i>
                      </strong>
                    </td>
                  </tr>
                </table>
              </div>

            </div>
          </b-card-header>

          <div
            v-if="issetActiveModifiersInItem(item)"
            class="sub-accordion">

            <b-card-body>
              <div class="order-sub">
                <div class="d-flex align-items-start">
                  <div class="order-icon">
                    <svg class="icon icon-icon-pros">
                      <use xlink:href="#icon-icon-pros"></use>
                    </svg>
                  </div>
                  <div class="order-inner">
                    <ul
                      no-body
                      v-for="modifier in item.modifiers"
                      v-bind:key="modifier.name"  class="list-unstyled mb-0">
                        <li v-if="!modifier.void_status">{{modifier.name}} (${{modifier.price.toFixed(2)}})</li>
                    </ul>
                  </div>
                </div>
              </div>
            </b-card-body>
          </div>
        </b-card>
      </div>
    </template>
    <TransactionModal :isSale="isSale" :sale="sale"/>
  </cd-layout>

</template>
<script>
import CdLayout from '../layouts/CdLayout'
import {mapGetters} from 'vuex'
import orderMixin from '@/mixins/orderMixin'
import TransactionModal from '../components/Modal/TransactionModal.vue'

export default {
  name: 'Order',
  components: {
    CdLayout,
    TransactionModal
  },
  data () {
    return {}
  },
  mixins: [orderMixin],
  methods: {},
  computed: {
    ...mapGetters([
      'orderItems',
      'cdIsOpen',
      'isSale',
      'sale'
    ])
  }
}
</script>
<style lang="scss">
  .list-complete-item {
    transition: all 1s;
  }

  .list-complete-enter, .list-complete-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }

  .list-complete-leave-active {
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/views/Order.vue